Ext.define('SA.VectorMapInfoLocationHighlightGeoJsonSourceData', {
    singleton: true,

    get({geographicRelease, infoLocation}) {
        if (!infoLocation) {
            return SA.GeoJson.createEmptyFeatureCollection();
        }

        var locationSeries = ['and', ['=', 'geographicRelease', geographicRelease], ['in', 'locationSeries', ...infoLocation.locationSeries]];

        return SA.VectorMapGeoJsonSourceDataUrls.forPolygons({locationSeries});
    }
});